<template>
  <span>
    <span :style="{color:actionColorList[scope.text]}">{{scope.text}}</span>
  </span>
</template>

<script>
export default {
  props: {
    instance: Object, // 插槽实例
    scope: Object // text, row, index
  },
  data() {
    return {
      actionColorList: {
        审查中: '#F08330',
        失效或无效: '#ADAFB8',
        有效: '#13BFA3'
      }
    }
  },
  components: {

  }
}
</script>
